<template>
  <v-dialog v-model="showModal" max-width="600" persistent>
    <v-card>
      <v-icon
        large
        class="p-1 position-absolute top-0 end-0 mt-2 me-2"
        @click="showModal = false"
      >
        mdi-close-thick
      </v-icon>

      <template v-if="loading">
        <div class="p-5">
          <v-progress-circular
            :size="70"
            :width="7"
            color="purple"
            indeterminate
          />
        </div>
      </template>

      <template v-else>
        <v-card-text>
          <v-icon class="mt-3" size="100" color="#a5dc86">
            mdi-check-circle-outline
          </v-icon>
          <p><b>Se generarán la notas de crédito</b></p>
          <p class="text-h6 mb-2">
            Monto del anticipo: ${{
              selectedInvoiceReference.DMBTR | formatCurrency
            }}
          </p>
          <p class="text-h6 mb-2">
            Monto amortizado: ${{ amortizedAmount | formatCurrency }}
          </p>
          <p class="text-h6 mb-2">
            Saldo: ${{ advanceBalance | formatCurrency }}
          </p>
          <p class="text-h6 mb-2">
            <span>Factura del bien: {{ invoiceWell }}</span>
            <span class="ml-3"
              >Importe: ${{ invoiceWellAmount | formatCurrency }}</span
            >
          </p>
          <p class="text-h6 mb-2">
            Importe NC aplicación anticipo: ${{
              advaceApplicationAmount | formatCurrency
            }}
          </p>
          <p class="text-h6 mb-2">
            Importe NC DPP: ${{ earlyPaymentDiscountAmount | formatCurrency }}
          </p>
        </v-card-text>

        <v-card-actions class="d-flex justify-content-center">
          <v-btn
            class="red-button rounded-pill mb-4 px-6"
            :disabled="isButtonGenerateDisable"
            @click="generateNC()"
          >
            GENERAR
          </v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
  import axios from '@/plugins/axios';
  export default {
    props: {
      selectedInvoiceWell: {
        required: true,
        type: Object,
      },
      selectedInvoiceReference: {
        required: true,
        type: Object,
      },
      customerCode: {
        required: true,
        type: String,
      },
      value: Boolean,
    },
    data() {
      return {
        isButtonGenerateDisable: false,
        amortizedAmount: 0,
        advanceBalance: 0,
        invoiceWell: '',
        invoiceWellAmount: 0,
        loading: false,
      };
    },
    computed: {
      earlyPaymentDiscountAmount() {
        const amountDPP = this.invoiceWellAmount * 0.97;
        return amountDPP <= this.advanceBalance
          ? this.invoiceWellAmount - amountDPP
          : 0;
      },
      advaceApplicationAmount() {
        return this.earlyPaymentDiscountAmount === 0
          ? this.advanceBalance
          : this.invoiceWellAmount - this.earlyPaymentDiscountAmount;
      },
      showModal: {
        set(newValue) {
          this.$emit('input', newValue);
        },
        get() {
          return this.value;
        },
      },
    },
    watch: {
      showModal(newValue) {
        if (newValue) {
          this.setInvoice();
        }
      },
    },
    methods: {
      setInvoice() {
        this.setAdvanceBalance();
        this.invoiceWell = this.selectedInvoiceWell.BELNR;
        this.invoiceWellAmount = this.selectedInvoiceWell.DMBTR;
      },
      async setAdvanceBalance() {
        this.isButtonGenerateDisable = false;
        this.loading = true;
        try {
          const { data } = await axios.get('/credit/advance-balance', {
            params: {
              KUNNR: this.customerCode,
              VBELN: this.selectedInvoiceReference.BELNR,
              MONTO: this.selectedInvoiceReference.DMBTR,
            },
          });

          this.advanceBalance = parseFloat(data.data?.P_SALDO ?? 0);
          this.amortizedAmount = parseFloat(data.data?.P_MAMOR ?? 0);
        } catch (error) {
          this.$toast.error('Ocurrió un error al obtener el saldo');
        } finally {
          this.loading = false;
        }
      },
      generateNC() {
        this.isButtonGenerateDisable = true;
        this.$emit('generate', {
          invoiceWell: this.invoiceWell,
          advaceApplicationAmount: this.advaceApplicationAmount,
          invoiceReference: this.selectedInvoiceReference.BELNR,
          earlyPaymentDiscountAmount: this.earlyPaymentDiscountAmount,
        });
      },
    },
  };
</script>
